export const BRAND_COLORS = {
  primary: "#f8f3df",
  secondary: "#f8f3df",
  background: "#f8f3df",
  text: "#2D3748",
  textLight: "#4A5568",
  water: "#e2dcc8",
  roads: {
    main: "#FFFFFF",
    outline: "#FFFFFF",
    motorway: "#FFFFFF",
    major: "#FFFFFF",
  },
  buildings: "#f8f3df",
  parks: "#e3deca",
  poi: {
    marker: "#6B46C1",
    border: "#FFFFFF",
  },
}

const tilesURLDev = "http://localhost:3002/tiles/{z}/{x}/{y}?tms=1"
const tilesURLProd = "http://localhost:5566/tiles/{z}/{x}/{y}"

const glyphsURLDev = "http://localhost:3002/fonts/{fontstack}/{range}.pbf"
const glyphsURLProd = "http://localhost:5566/fonts/{fontstack}/{range}.pbf"

export const style = {
  version: 8,
  glyphs: glyphsURLProd,
  sources: {
    "mbtiles-source": {
      type: "vector",
      tiles: [tilesURLProd],
      minzoom: 0,
      maxzoom: 14,
    },
  },
  layers: [
    {
      id: "background",
      type: "background",
      paint: {
        "background-color": BRAND_COLORS.background,
      },
    },
    {
      id: "landuse",
      type: "fill",
      source: "mbtiles-source",
      "source-layer": "landuse",
      paint: {
        "fill-color": [
          "match",
          ["get", "class"],
          "park",
          BRAND_COLORS.parks,
          BRAND_COLORS.background,
        ],
      },
    },
    {
      id: "water",
      type: "fill",
      source: "mbtiles-source",
      "source-layer": "water",
      paint: {
        "fill-color": BRAND_COLORS.water,
      },
    },
    {
      id: "buildings",
      type: "fill",
      source: "mbtiles-source",
      "source-layer": "building",
      paint: {
        "fill-color": BRAND_COLORS.buildings,
        "fill-opacity": 0.8,
        "fill-outline-color": BRAND_COLORS.roads.outline,
      },
    },
    {
      id: "roads-outline",
      type: "line",
      source: "mbtiles-source",
      "source-layer": "transportation",
      paint: {
        "line-color": BRAND_COLORS.roads.outline,
        "line-width": [
          "match",
          ["get", "class"],
          "motorway",
          6,
          "trunk",
          5,
          "primary",
          4,
          "secondary",
          3,
          "tertiary",
          2,
          1, // default
        ],
      },
    },
    {
      id: "roads",
      type: "line",
      source: "mbtiles-source",
      "source-layer": "transportation",
      paint: {
        "line-color": [
          "match",
          ["get", "class"],
          "motorway",
          BRAND_COLORS.roads.motorway,
          "trunk",
          BRAND_COLORS.roads.major,
          "primary",
          BRAND_COLORS.roads.major,
          "secondary",
          BRAND_COLORS.roads.main,
          "tertiary",
          BRAND_COLORS.roads.main,
          BRAND_COLORS.roads.main, // default
        ],
        "line-width": [
          "match",
          ["get", "class"],
          "motorway",
          4,
          "trunk",
          3,
          "primary",
          2,
          "secondary",
          1.5,
          "tertiary",
          1,
          0.5, // default
        ],
      },
    },
    {
      id: "road-labels",
      type: "symbol",
      source: "mbtiles-source",
      "source-layer": "transportation_name",
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Regular"],
        "text-size": 12,
        "symbol-placement": "line",
        "text-anchor": "center",
        "text-letter-spacing": 0.1,
      },
      paint: {
        "text-color": BRAND_COLORS.textLight,
        "text-halo-color": BRAND_COLORS.background,
        "text-halo-width": 2,
      },
    },
    {
      id: "place-labels",
      type: "symbol",
      source: "mbtiles-source",
      "source-layer": "place",
      layout: {
        "text-field": ["get", "name"],
        "text-font": ["Noto Sans Regular"],
        "text-size": [
          "match",
          ["get", "class"],
          "city",
          16,
          "town",
          14,
          "village",
          12,
          10,
        ],
        "text-anchor": "center",
        "text-transform": [
          "match",
          ["get", "class"],
          "city",
          "uppercase",
          "town",
          "uppercase",
          "normal",
        ],
      },
      paint: {
        "text-color": BRAND_COLORS.text,
        "text-halo-color": BRAND_COLORS.background,
        "text-halo-width": 2,
      },
    },
  ],
}
